export default "__VITE_ASSET__f9221c97__"